/* Garland Classic — theme scripts (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var routes = window.themeRoutes || {};
  var settings = window.themeSettings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = settings.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  /* ---------------- Announcement slider ---------------- */
  $all('[data-announcement]').forEach(function (bar) {
    var slides = $all('[data-announcement-slide]', bar);
    if (slides.length < 2) return;
    var index = 0;
    var delay = parseInt(bar.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;
    function show(i) {
      var prevSlide = slides[index];
      prevSlide.classList.remove('is-active');
      prevSlide.classList.add('is-leaving');
      setTimeout(function () { prevSlide.classList.remove('is-leaving'); }, 500);
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    }
    function start() { if (delay > 0) { stop(); timer = setInterval(function () { show(index + 1); }, delay * 1000); } }
    function stop() { if (timer) clearInterval(timer); }
    var prev = $('[data-announcement-prev]', bar);
    var next = $('[data-announcement-next]', bar);
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    start();
  });

  /* ---------------- Sticky header shadow + header height var ---------------- */
  var headerSection = $('.section-header');
  function setHeaderHeight() {
    if (headerSection) document.documentElement.style.setProperty('--header-height', headerSection.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  /* ---------------- Scroll-driven UI ---------------- */
  var scrollTopBtn = $('[data-scroll-top]');
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
  function onScroll() {
    var y = window.pageYOffset;
    if (headerSection) headerSection.classList.toggle('is-scrolled', y > 10);
    if (scrollTopBtn) scrollTopBtn.classList.toggle('is-visible', y > 600);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------------- Drawers (menu, search) ---------------- */
  function openEl(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('input, button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeEl(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openEl(document.getElementById(opener.getAttribute('data-open')));
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      closeEl(closer.closest('.menu-drawer, .search-modal, .promo-popup'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $all('.menu-drawer.is-open, .search-modal.is-open, .promo-popup.is-open').forEach(closeEl);
    closeCart();
  });

  /* ---------------- Product gallery ---------------- */
  function initGallery(gallery) {
    var track = $('[data-gallery-track]', gallery);
    if (!track) return;
    var slides = $all('[data-gallery-slide]', gallery);
    var dots = $all('[data-gallery-dot]', gallery);
    var thumbs = $all('[data-gallery-thumb]', gallery);
    function goTo(i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function setActive(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      gallery.setAttribute('data-current', i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      });
    }, { passive: true });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    function current() { return parseInt(gallery.getAttribute('data-current') || '0', 10); }
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, current() + 1)); });
    gallery.goToMedia = function (mediaId) {
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].getAttribute('data-media-id') === String(mediaId)) { goTo(n); return; }
      }
    };
    setActive(0);
  }
  $all('[data-gallery]').forEach(initGallery);

  /* ---------------- Ships-by date ---------------- */
  $all('[data-ships-by]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-ships-by'), 10) || 1;
    var skipWeekends = el.getAttribute('data-skip-weekends') === 'true';
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skipWeekends && (d.getDay() === 0 || d.getDay() === 6)) continue;
      added++;
    }
    el.textContent = d.toLocaleDateString(undefined, { weekday: 'short', month: 'long', day: 'numeric' });
  });

  /* ---------------- Product form + variants ---------------- */
  function initProduct(section) {
    var dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var form = $('form[data-product-form]', section);
    var idInput = form ? $('input[name="id"]', form) : null;
    var pickers = $all('[data-option-index]', section);
    var gallery = $('[data-gallery]', section);
    var submit = $('[data-add-to-cart]', section);
    var submitText = submit ? $('[data-add-to-cart-text]', submit) : null;
    var defaultText = submit ? submit.getAttribute('data-default-text') : '';
    var soldOutText = submit ? submit.getAttribute('data-sold-out-text') : 'Sold out';

    function selectedOptions() {
      var opts = [];
      pickers.forEach(function (fieldset) {
        var i = parseInt(fieldset.getAttribute('data-option-index'), 10);
        var checked = fieldset.querySelector('input:checked');
        var select = fieldset.querySelector('select');
        opts[i] = checked ? checked.value : (select ? select.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { match = false; break; } }
        if (match) return v;
      }
      return null;
    }
    function updatePrice(v) {
      $all('[data-price-wrapper]', section).forEach(function (wrap) {
        var priceEl = $('[data-price]', wrap);
        var compareEl = $('[data-compare-price]', wrap);
        var badge = $('[data-sale-badge]', wrap);
        var pctEl = $('[data-saved-pct]', wrap);
        var soldBadge = $('[data-sold-out-badge]', wrap);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) { compareEl.textContent = onSale ? formatMoney(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
        if (badge) badge.hidden = !onSale || !v.available;
        if (pctEl && onSale) pctEl.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        if (soldBadge) soldBadge.hidden = v.available;
        wrap.classList.toggle('price--on-sale', !!onSale);
      });
      $all('[data-sticky-price]').forEach(function (el) { el.textContent = formatMoney(v.price); });
    }
    function updateButton(v) {
      $all('[data-add-to-cart], [data-sticky-atc-button]', document).forEach(function (btn) {
        var text = btn.querySelector('[data-add-to-cart-text]') || btn;
        if (!v) { btn.disabled = true; text.textContent = 'Unavailable'; return; }
        btn.disabled = !v.available;
        text.textContent = v.available ? (btn.getAttribute('data-default-text') || defaultText) : (btn.getAttribute('data-sold-out-text') || soldOutText);
      });
    }
    function updateAvailability(opts) {
      pickers.forEach(function (fieldset) {
        var i = parseInt(fieldset.getAttribute('data-option-index'), 10);
        $all('input', fieldset).forEach(function (input) {
          var test = opts.slice(); test[i] = input.value;
          var v = findVariant(test);
          var label = fieldset.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
        var legendValue = fieldset.querySelector('[data-selected-value]');
        if (legendValue) legendValue.textContent = opts[i] || '';
      });
    }
    function onChange() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      updateAvailability(opts);
      updateButton(v);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      updatePrice(v);
      if (v.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(v.featured_media.id);
      if (section.hasAttribute('data-update-url') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    pickers.forEach(function (fieldset) { fieldset.addEventListener('change', onChange); });
    if (pickers.length) updateAvailability(selectedOptions());

    /* Quantity steppers */
    $all('[data-qty]', section).forEach(initQty);

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (settings.cartType !== 'drawer') return;
        e.preventDefault();
        var errorEl = $('[data-form-error]', section);
        if (errorEl) errorEl.hidden = true;
        if (submit) { submit.classList.add('is-loading'); submit.setAttribute('aria-disabled', 'true'); }
        var body = new FormData(form);
        fetch((routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
            return refreshCart(true);
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () {
            if (submit) { submit.classList.remove('is-loading'); submit.removeAttribute('aria-disabled'); }
          });
      });
    }

    /* Sticky ATC (mobile) */
    var sticky = $('[data-sticky-atc]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !en.isIntersecting && below);
        });
      });
      io.observe(submit);
      var stickyBtn = $('[data-sticky-atc-button]', sticky);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
          else submit.click();
        }
      });
    }
  }
  $all('[data-product-section]').forEach(initProduct);

  function initQty(wrap) {
    var input = $('input', wrap);
    var minus = $('[data-qty-minus]', wrap);
    var plus = $('[data-qty-plus]', wrap);
    if (!input) return;
    function set(val) {
      var min = parseInt(input.min || '0', 10);
      if (isNaN(val) || val < min) val = min;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (minus) minus.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = $('[data-cart-drawer]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    startCartTimer();
    var panel = $('.cart-drawer__panel', drawer);
    if (panel) panel.focus();
  }
  function closeCart() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshCart(open) {
    var root = routes.root_url || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return fetch(root + '?sections=cart-drawer-content,cart-count-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parser = new DOMParser();
        if (drawer && data['cart-drawer-content']) {
          var doc = parser.parseFromString(data['cart-drawer-content'], 'text/html');
          var fresh = doc.querySelector('.shopify-section');
          var holder = $('[data-cart-drawer-inner]', drawer);
          if (fresh && holder) {
            holder.innerHTML = fresh.outerHTML;
            bindDrawer();
          }
        }
        if (data['cart-count-bubble']) {
          var bdoc = parser.parseFromString(data['cart-count-bubble'], 'text/html');
          var count = bdoc.querySelector('[data-cart-count-value]');
          var n = count ? parseInt(count.getAttribute('data-cart-count-value'), 10) : 0;
          $all('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
        }
        if (open) {
          if (drawer) openCart();
          else window.location.href = routes.cart_url || '/cart';
        }
      });
  }

  function changeLine(key, qty) {
    return fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(false); });
  }

  function addVariant(id, qty) {
    return fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function () { return refreshCart(false); });
  }

  var timerInterval = null;
  function startCartTimer() {
    var el = drawer ? $('[data-cart-timer]', drawer) : null;
    if (!el) return;
    var minutes = parseInt(el.getAttribute('data-cart-timer'), 10) || 10;
    var key = 'cartTimerEnd';
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }
    if (!end || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(key, String(end)); } catch (e) { /* storage unavailable */ }
    }
    var out = $('[data-cart-timer-value]', el);
    function tick() {
      var left = Math.max(0, end - Date.now());
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      if (out) out.textContent = m + ':' + (s > 9 ? s : '0' + s);
    }
    clearInterval(timerInterval);
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  function bindDrawer() {
    if (!drawer) return;
    $all('[data-cart-close]', drawer).forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
    });
    $all('[data-line-key]', drawer).forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var input = $('[data-qty] input', line);
      $all('[data-qty]', line).forEach(initQty);
      if (input) input.addEventListener('change', function () { changeLine(key, parseInt(input.value, 10) || 0); });
      var remove = $('[data-line-remove]', line);
      if (remove) remove.addEventListener('click', function (e) { e.preventDefault(); changeLine(key, 0); });
    });
    $all('[data-upsell-add]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.disabled = true;
        addVariant(btn.getAttribute('data-upsell-add'), 1);
      });
    });
    startCartTimer();
  }

  if (drawer) {
    bindDrawer();
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
    });
    $all('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
  }

  /* ---------------- Cart page quantity forms ---------------- */
  $all('[data-cart-page] [data-qty]').forEach(initQty);
  $all('[data-cart-page] [data-qty] input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------------- Reviews carousel arrows ---------------- */
  $all('[data-reviews]').forEach(function (wrap) {
    var track = $('[data-reviews-track]', wrap);
    if (!track) return;
    function step() {
      var card = track.querySelector('.review-card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    }
    var prev = $('[data-reviews-prev]', wrap);
    var next = $('[data-reviews-next]', wrap);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------------- Promo popup ---------------- */
  $all('[data-promo-popup]').forEach(function (popup) {
    if (window.Shopify && window.Shopify.designMode) return;
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 5;
    var key = 'promoPopupSeen';
    var seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch (e) { seen = false; }
    if (seen) return;
    setTimeout(function () {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      try { localStorage.setItem(key, '1'); } catch (e) { /* storage unavailable */ }
    }, delay * 1000);
  });
})();
